import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2010"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"5.943\" cy=\"2.499\" r=\"1\"></circle><circle cx=\"14.036\" cy=\"6.182\" r=\"1\"></circle><circle cx=\"3.846\" cy=\"12.721\" r=\"1.308\"></circle><path d=\"M9.528 3.891a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0zm-1.49 7.358a.871.871 0 1 0 0 1.742.871.871 0 0 0 0-1.742z\"></path><path d=\"M12.817 4.107c0-1.716-1.305-3.112-2.908-3.112H8.696a.7.7 0 1 0 0 1.4h1.213c.831 0 1.507.768 1.507 1.712s-.676 1.712-1.507 1.712H1.686a.7.7 0 1 0 0 1.4H9.91c1.602.001 2.907-1.396 2.907-3.112zm-1.351 4.516H2.635a.7.7 0 1 0 0 1.4h8.832c.921 0 1.67.809 1.67 1.804s-.749 1.805-1.67 1.805h-1.303a.7.7 0 1 0 0 1.4h1.303c1.693 0 3.071-1.438 3.071-3.205-.001-1.766-1.378-3.204-3.072-3.204z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }